// extracted by mini-css-extract-plugin
module.exports = {"root":"styles_root__3Fgfd","colMin":"styles_colMin__1l8DY"};